import { Children, FC, PropsWithChildren, useEffect, useLayoutEffect, useRef } from 'react';

import { renderTranscriptItem } from '../../lib/renderTranscriptItem';
import { ChatTranscriptWrapper, FadeIn, ScrollBox } from './ChatTranscript.styles';
import { IChatProps } from '../Chat';

export interface IChatTranscriptProps {
  downloadAttachment: IChatProps['downloadAttachment'];
  transcript?: connect.ChatTranscriptItem[];
}

export const ChatTranscript: FC<PropsWithChildren<IChatTranscriptProps>> = ({
  children,
  downloadAttachment,
  transcript
}) => {
  const scrollBoxRef = useRef<HTMLDivElement>(null);
  const childCount = Children.toArray(children).length;
  const lastItem = transcript?.[transcript.length - 1];

  useLayoutEffect(() => {
    // Hack to force Safari to recalculate its layout measurements (iOS in particular)
    // This only seems to be necessary when using 'column-reverse'. Likely to revisit this
    // in the future to manually control how the scroll sticks to the bottom, at which
    // point 'column-reverse' and this hack would no longer be necessary.
    scrollBoxRef.current?.scrollBy?.({ top: -1 });
    scrollBoxRef.current?.scrollBy?.({ top: 1 });
  }, [lastItem, childCount]);

  useEffect(() => {
    // Scroll down for new messages (0 is bottom with 'column-reverse')
    scrollBoxRef.current?.scrollTo?.({ top: 0, behavior: 'smooth' });
  }, [lastItem, childCount]);

  return (
    <ScrollBox ref={scrollBoxRef}>
      <ChatTranscriptWrapper role="log" aria-live="polite">
        {transcript?.map((item, index) => (
          <FadeIn key={item.Id}>{renderTranscriptItem({ item, index, transcript, downloadAttachment })}</FadeIn>
        ))}
        {children}
      </ChatTranscriptWrapper>
    </ScrollBox>
  );
};

ChatTranscript.displayName = 'ChatTranscript';
